<template>
  <v-container fluid class="home-portfolio-carousel">
    <v-row>
      <v-col>
        <h1 class="px-3">Featured Projects</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <transition name="fade" mode="out-in">
          <template v-for="(slide, index) in portfolioSlides">
            <v-container
              class="main-carousel-container"
              fluid
              :key="index"
              v-if="index === activeSlide"
            >
              <v-row>
                <v-col cols="12" :sm="(slide.screens.iphone.length > 0) ? 8 : 6">
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" :md="(slide.screens.iphone.length > 0) ? 9 : 12">
                        <div
                          class="bg-mac"
                          ref="macContainer"
                          :style="{
                          height: macContainerHeight + 'px'
                        }"
                        >
                          <div class="img-container">
                            <v-carousel
                              :height="macContainerHeight * 0.765"
                              :show-arrows="false"
                              :hide-delimiters="true"
                              cycle
                            >
                              <v-carousel-item
                                v-for="(item,i) in slide.screens.mac"
                                :key="'mac_' + i"
                                :src="item"
                                :height="macContainerHeight * 0.765"
                              ></v-carousel-item>
                            </v-carousel>
                            <!-- <img :src="slide.screens.mac[0]" /> -->
                          </div>
                        </div>
                      </v-col>
                      <v-col v-if="slide.screens.iphone.length > 0" cols="12" md="3">
                        <div
                          class="bg-iphone"
                          ref="iphoneContainer"
                          :style="{
                          height: macContainerHeight + 'px'
                        }"
                        >
                          <div
                            class="img"
                            :style="{
                            height: macContainerHeight + 'px'
                          }"
                          >
                            <v-carousel
                              :show-arrows="false"
                              :hide-delimiters="true"
                              cycle
                              :height="iphoneContainerHeight"
                              :style="{
                                'margin-top': iphoneContainerPadding + 'px',
                                width: iphoneContainerHeight * 0.465 + 'px'
                              }"
                              style="margin-left: auto; margin-right: auto"
                            >
                              <v-carousel-item
                                v-for="(item,i) in slide.screens.iphone"
                                :key="'iphone_' + i"
                                :src="item"
                                :height="iphoneContainerHeight"
                              ></v-carousel-item>
                            </v-carousel>
                          </div>
                          <div
                            class="frame"
                            :style="{
                            height: macContainerHeight + 'px'
                          }"
                          ></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
                <v-col cols="12" :sm="(slide.screens.iphone.length > 0) ? 4 : 6">
                  <v-container fluid>
                    <v-row>
                      <v-col>
                        <h2 class="display-1">{{ slide.title }}</h2>
                        <br />
                        <a :href="slide.url" target="_blank" class="project-href">{{ slide.url }}</a>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>{{ slide.description }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-icon
                          v-for="(tech, idx1) in slide.tech"
                          :key="index+'tech'+idx1"
                          v-html="'fab fa-'+tech"
                          class="px-2 py-1"
                        ></v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </transition>
      </v-col>
    </v-row>
    <v-row wrap justify="center" class="px-2 switcher-panel">
      <template v-for="(slide, index) in portfolioSlides">
        <v-col cols="6" class="col-xs-6 col-sm-4 col-md-3 col-lg-2" :key="'switch' + index">
          <div class="switcher" :class="{ active: activeSlide === index}">
            <img :src="slide.logo" @click="activeSlide = index" />
          </div>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomePortfolioCarousel",
  data: () => ({
    activeSlide: 0,
    macContainerHeight: 0,
    iphoneContainerHeight: 0,
    iphoneContainerPadding: 0,
    portfolioSlides: [
      {
        title: "Prodoge",
        url: "https://prodoge.com/",
        description:
          "Prodoge is a platform for global business and anyone with the Prodoge mobile app can get started sending payments, promoting their business, and selling their goods & services in under a minute to anyone in the world.",
        logo: "/img/portfolio/prodoge/logo.png",
        tech: ["apple", "android", "node", "btc", "html5", "aws"],
        screens: {
          mac: [
            "/img/portfolio/prodoge/screens/prodoge-pc-1.png"
            // "/img/portfolio/prodoge/screens/prodoge-pc-2.png"
            // '/img/portfolio/fotofy/screens/fotofy-pc-3.png'
          ],
          iphone: [
            "/img/portfolio/prodoge/screens/prodoge-iphone-1.png",
            "/img/portfolio/prodoge/screens/prodoge-iphone-2.png",
            "/img/portfolio/prodoge/screens/prodoge-iphone-3.png"
          ]
        }
      },
      {
        title: "VocabNetwork",
        url: "https://vocabnetwork.com/",
        description:
          "VocabNetwork gives you what you need to succeed. Be confident in your English",
        logo: "/img/portfolio/vocabnetwork/logo.png",
        tech: ["vuejs", "html5", "css3"],
        screens: {
          mac: [
            "/img/portfolio/vocabnetwork/screens/vocabnetwork-pc-1.png",
            "/img/portfolio/vocabnetwork/screens/vocabnetwork-pc-2.png"
          ],
          iphone: [
            "/img/portfolio/vocabnetwork/screens/vocabnetwork-iphone-1.png",
            "/img/portfolio/vocabnetwork/screens/vocabnetwork-iphone-2.png"
          ]
        }
      },
      {
        title: "ImageProtect",
        url: "https://www.imageprotect.com/",
        description:
          "Image Protect is a revolutionary technology platform for image rights management and protection, which seamlessly registers, manages, and monetizes digital content for the creative community.",
        logo: "/img/portfolio/imageprotect/logo.png",
        tech: ["js-square", "php", "html5", "css3", "aws"],
        screens: {
          mac: [
            "/img/portfolio/imageprotect/screens/imageprotect-pc-1.png",
            "/img/portfolio/imageprotect/screens/imageprotect-pc-2.png"
          ],
          iphone: []
        }
      },
      {
        title: "Fotofy",
        url: "https://fotofy.com",
        description:
          "Publishers and photographers get paid to use high resolution photos. Freely access embeddable images to create stunning websites, blogs, social media posts, stories, email communication, forum posts, and more.",
        logo: "/img/portfolio/fotofy/logo.png",
        tech: ["vuejs", "node", "html5", "css3", "aws"],
        screens: {
          mac: [
            "/img/portfolio/fotofy/screens/fotofy-pc-1.png",
            "/img/portfolio/fotofy/screens/fotofy-pc-4.png"
            // '/img/portfolio/fotofy/screens/fotofy-pc-3.png'
          ],
          iphone: [
            "/img/portfolio/fotofy/screens/fotofy-iphone-1.png",
            "/img/portfolio/fotofy/screens/fotofy-iphone-2.png"
          ]
        }
      },
      {
        title: "Intri",
        url: "https://intri.com/",
        description:
          "Intri is a new social media app that you can use to meet and connect with people in your area who share your interests and hobbies.",
        logo: "/img/portfolio/intri/logo.png",
        tech: ["apple", "android", "node", "aws"],
        screens: {
          mac: ["/img/portfolio/intri/screens/intri-pc-2.png"],
          iphone: [
            "/img/portfolio/intri/screens/intri-iphone-1a.png",
            "/img/portfolio/intri/screens/intri-iphone-2a.png"
          ]
        }
      }
    ]
  }),
  watch: {
    activeSlide() {
      this.setMacProperHeight();
      this.setIphoneImgProperHeight();
    }
  },
  computed: {
    macContainerWith() {
      return this.$refs.macContainer[0].clientwidth;
    }
  },
  mounted() {
    let his = this;
    window.addEventListener("resize", () => {
      his.setMacProperHeight();
      his.setIphoneImgProperHeight();
    });
    this.setMacProperHeight();
    this.setIphoneImgProperHeight();
  },
  methods: {
    setMacProperHeight() {
      for (let i = 0; i < this.$refs.macContainer.length; i++) {
        this.macContainerHeight = parseInt(
          this.$refs.macContainer[i].clientWidth * 0.57
        );
      }
    },
    setIphoneImgProperHeight() {
      this.iphoneContainerHeight = this.macContainerHeight * 0.94;
      this.iphoneContainerPadding = this.iphoneContainerHeight * 0.031;
    }
  }
};
</script>
<style lang="scss">
.home-portfolio-carousel {
  background: #fff;
  color: #333;
  padding: 25px;

  .fade-enter-active {
    animation: bounce-in 0.5s;
  }
  .fade-leave-active {
    animation: bounce-in 0.5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .project-href {
    color: #3333ff;
  }
  .switcher-panel {
    min-height: 110px;
    height: 110;

    .switcher {
      padding: 15px;
      max-width: 200px;
      margin: 0 auto;
      line-height: 90px;
      text-align: center;
      cursor: pointer;
      img {
        width: 90%;
        vertical-align: middle;

        // display: block;
        // margin: 0 auto;
      }

      &:hover {
        // padding: 10px;
        img {
          width: 100%;
          // display: block;
          // margin: 0 auto;
        }
      }
      &.active {
        border-radius: 10px;
        background-color: rgba($color: #1a4658, $alpha: 0.2);
      }
    }
  }
  .bg-mac {
    background-image: url("/img/portfolio/macbook.png");
    background-position: center top;
    background-size: contain;
    background-repeat: no-repeat;
    padding: 5.8% 14.7% 0px 15.8%;
    width: 100%;
    overflow: hidden;
    .img-container {
      overflow: hidden;
      width: 100%;
      display: block;
      height: 90%;
      .v-image__image {
        background-position: top center !important;
      }
      img {
        width: 100%;
        object-fit: cover;
        height: 94%;
        object-position: 0% 0px;
      }
    }
  }
  .bg-iphone {
    width: 100%;
    overflow: hidden;
    position: relative;
    .img {
      img {
        margin: 0 auto;
        display: block;
      }
    }
    .frame {
      position: absolute;
      background-image: url("/img/portfolio/iphonex.png");
      background-position: center top;
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      top: 0;
    }
  }
  .main {
    margin-bottom: 30px;
  }
  .theme--dark.v-icon {
    color: #666 !important;
  }
}
</style>